import Vue from 'vue';
import App from './App.vue';

import store from './store'
import './css/style.css';

import { VueMaskDirective } from 'v-mask';
import vuetify from './plugins/vuetify';
import router from './router';

import VueGtag from "vue-gtag";


Vue.use(VueGtag, {
  config: { id: "G-RH642CMNSZ" },
  pageTrackerTemplate() {
    return {
      timestamp: new Date().toISOString(),
      id_usuario: store.state.user.scope ? store.state.user.scope.idUsuario : 0,
      session_key: store.state.token
    }
  }
}, router);

Vue.config.productionTip = false;

Vue.directive('mask', VueMaskDirective);

Vue.prototype.$drink_uri = 'https://diageodrinkonomics.com.br/api';
Vue.prototype.$drink_img_uri = 'https://diageodrinkonomics.com.br/public/img/';

// Vue.prototype.$drink_uri = 'http://localhost:8082/api';
// Vue.prototype.$drink_img_uri = 'http://localhost:8082/img/';

Vue.filter('filterLitragem', function (value) {
  if (value) {
    let litragens = value.split(",");
    let lit = ""
    litragens.forEach(litragem => {
      lit += " " + litragem + " ou"
    });
    return lit.substring(0, lit.length - 2);
  }
});
Vue.filter('filterQtdeDoses', function (value) {
  if (value) {
    let litragens = value.split(",");
    let qtdeDoses = ""
    litragens.forEach(litragem => {
      qtdeDoses += " " + litragem / 50 + " ou"
    });
    return qtdeDoses.substring(0, qtdeDoses.length - 2);
  }
});


new Vue({
  render: (h) => h(App),
  store,
  router,
  vuetify,
}).$mount('#app');
